export default __webpack_public_path__ + "static/media/availability.1b58cba6.png";